module.exports = {
  "functions": [
    {
      "name": "goTo",
      "signature": "() => void",
      "description": {
        "en": "Scroll to target location, using provided options",
        "zh-Hans": "",
        "eo-UY": ""
      }
    }
  ],
  "props": [],
  "name": "$vuetify",
  "sass": [
    {
      "name": "$color-pack",
      "default": "true !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$body-font-family",
      "default": "'Roboto', sans-serif !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$font-size-root",
      "default": "16px !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$line-height-root",
      "default": "1.5 !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$border-radius-root",
      "default": "4px !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$rounded",
      "default": "map-deep-merge(\n  (\n    0: 0,\n    'sm': $border-radius-root / 2,\n    null: $border-radius-root,\n    'lg': $border-radius-root * 2,\n    'xl': $border-radius-root * 6,\n    'pill': 9999px,\n    'circle': 50%\n  ),\n  $rounded\n);",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$spacer",
      "default": "4px !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$spacers",
      "default": "@if (type-of($spacers) == list) {\n  @for $i from 0 through 16 {\n    $spacers: map-merge($spacers, ($i: $spacer * $i))\n  }\n}\n\n$negative-spacers: () !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$grid-breakpoints",
      "default": "map-deep-merge(\n  (\n    'xs': 0,\n    'sm': 600px,\n    'md': 960px,\n    'lg': 1280px - 16px,\n    'xl': 1920px - 16px\n  ),\n  $grid-breakpoints\n);",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$grid-gutter",
      "default": "$spacer * 6 !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$form-grid-gutter",
      "default": "$spacer * 2 !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$grid-columns",
      "default": "12 !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$container-padding-x",
      "default": "$grid-gutter / 2 !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$grid-gutters",
      "default": "map-deep-merge(\n  (\n    'xs': $grid-gutter / 12,\n    'sm': $grid-gutter / 6,\n    'md': $grid-gutter / 3,\n    'lg': $grid-gutter * 2/3,\n    'xl': $grid-gutter\n  ),\n  $grid-gutters\n);",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$container-max-widths",
      "default": "map-deep-merge(\n  (\n    'md': map-get($grid-breakpoints, 'md') * 0.9375,\n    'lg': map-get($grid-breakpoints, 'lg') * 0.9375,\n    'xl': map-get($grid-breakpoints, 'xl') * 0.9375\n  ),\n  $container-max-widths\n);",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$display-breakpoints",
      "default": "map-deep-merge(\n  (\n    'print-only': 'only print',\n    'screen-only': 'only screen',\n    'xs-only': 'only screen and (max-width: #{map-get($grid-breakpoints, 'sm') - 1})',\n    'sm-only': 'only screen and (min-width: #{map-get($grid-breakpoints, 'sm')}) and (max-width: #{map-get($grid-breakpoints, 'md') - 1})',\n    'sm-and-down': 'only screen and (max-width: #{map-get($grid-breakpoints, 'md') - 1})',\n    'sm-and-up': 'only screen and (min-width: #{map-get($grid-breakpoints, 'sm')})',\n    'md-only': 'only screen and (min-width: #{map-get($grid-breakpoints, 'md')}) and (max-width: #{map-get($grid-breakpoints, 'lg') - 1})',\n    'md-and-down': 'only screen and (max-width: #{map-get($grid-breakpoints, 'lg') - 1})',\n    'md-and-up': 'only screen and (min-width: #{map-get($grid-breakpoints, 'md')})',\n    'lg-only': 'only screen and (min-width: #{map-get($grid-breakpoints, 'lg')}) and (max-width: #{map-get($grid-breakpoints, 'xl') - 1})',\n    'lg-and-down': 'only screen and (max-width: #{map-get($grid-breakpoints, 'xl') - 1})',\n    'lg-and-up': 'only screen and (min-width: #{map-get($grid-breakpoints, 'lg')})',\n    'xl-only': 'only screen and (min-width: #{map-get($grid-breakpoints, 'xl')})'\n  ),\n  $display-breakpoints\n);",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$font-weights",
      "default": "map-deep-merge(\n  (\n    'thin': 100,\n    'light': 300,\n    'regular': 400,\n    'medium': 500,\n    'bold': 700,\n    'black': 900\n  ),\n  $font-weights\n);",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$heading-font-family",
      "default": "$body-font-family !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$headings",
      "default": "map-deep-merge(\n  (\n    'h1': (\n      'size': 6rem,\n      'weight': 300,\n      'line-height': 6rem,\n      'letter-spacing': -.015625em,\n      'font-family': $heading-font-family,\n      'text-transform': false\n    ),\n    'h2': (\n      'size': 3.75rem,\n      'weight': 300,\n      'line-height': 3.75rem,\n      'letter-spacing': -.0083333333em,\n      'font-family': $heading-font-family,\n      'text-transform': false\n    ),\n    'h3': (\n      'size': 3rem,\n      'weight': 400,\n      'line-height': 3.125rem,\n      'letter-spacing': normal,\n      'font-family': $heading-font-family,\n      'text-transform': false\n    ),\n    'h4': (\n      'size': 2.125rem,\n      'weight': 400,\n      'line-height': 2.5rem,\n      'letter-spacing': .0073529412em,\n      'font-family': $heading-font-family,\n      'text-transform': false\n    ),\n    'h5': (\n      'size': 1.5rem,\n      'weight': 400,\n      'line-height': 2rem,\n      'letter-spacing': normal,\n      'font-family': $heading-font-family,\n      'text-transform': false\n    ),\n    'h6': (\n      'size': 1.25rem,\n      'weight': 500,\n      'line-height': 2rem,\n      'letter-spacing': .0125em,\n      'font-family': $heading-font-family,\n      'text-transform': false\n    ),\n    'subtitle-1': (\n      'size': 1rem,\n      'weight': normal,\n      'line-height': 1.75rem,\n      'letter-spacing': .009375em,\n      'font-family': $body-font-family,\n      'text-transform': false\n    ),\n    'subtitle-2': (\n      'size': .875rem,\n      'weight': 500,\n      'line-height': 1.375rem,\n      'letter-spacing': .0071428571em,\n      'font-family': $body-font-family,\n      'text-transform': false\n    ),\n    'body-1': (\n      'size': 1rem,\n      'weight': 400,\n      'line-height': 1.5rem,\n      'letter-spacing': .03125em,\n      'font-family': $body-font-family,\n      'text-transform': false\n    ),\n    'body-2': (\n      'size': .875rem,\n      'weight': 400,\n      'line-height': 1.25rem,\n      'letter-spacing': .0178571429em,\n      'font-family': $body-font-family,\n      'text-transform': false\n    ),\n    'button': (\n      'size': .875rem,\n      'weight': 500,\n      'line-height': 2.25rem,\n      'letter-spacing': .0892857143em,\n      'font-family': $body-font-family,\n      'text-transform': uppercase\n    ),\n    'caption': (\n      'size': .75rem,\n      'weight': 400,\n      'line-height': 1.25rem,\n      'letter-spacing': .0333333333em,\n      'font-family': $body-font-family,\n      'text-transform': false\n    ),\n    'overline': (\n      'size': .75rem,\n      'weight': 500,\n      'line-height': 2rem,\n      'letter-spacing': .1666666667em,\n      'font-family': $body-font-family,\n      'text-transform': uppercase\n    )\n  ),\n  $headings\n);",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$typography",
      "default": "@each $type, $values in $headings {\n  $typography: map-deep-merge(\n    $typography,\n    (#{$type}: map-values($values))\n  );",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$transition",
      "default": "map-deep-merge(\n  (\n    'fast-out-slow-in': cubic-bezier(0.4, 0, 0.2, 1),\n    'linear-out-slow-in': cubic-bezier(0, 0, 0.2, 1),\n    'fast-out-linear-in': cubic-bezier(0.4, 0, 1, 1),\n    'ease-in-out': cubic-bezier(0.4, 0, 0.6, 1),\n    'fast-in-fast-out': cubic-bezier(0.25, 0.8, 0.25, 1),\n    'swing': cubic-bezier(0.25, 0.8, 0.5, 1)\n  ),\n  $transition\n);",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$primary-transition",
      "default": "0.3s map-get($transition, 'swing') !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$secondary-transition",
      "default": "0.2s map-get($transition, 'ease-in-out') !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$ripple-animation-transition-in",
      "default": "transform 0.25s map-get($transition, 'fast-out-slow-in'), opacity 0.1s map-get($transition, 'fast-out-slow-in') !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$ripple-animation-transition-out",
      "default": "opacity 0.3s map-get($transition, 'fast-out-slow-in') !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$ripple-animation-visible-opacity",
      "default": "0.15 !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$bootable-transition",
      "default": "0.2s map-get($transition, 'fast-out-slow-in') !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$blockquote-font-size",
      "default": "18px !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$blockquote-font-weight",
      "default": "300 !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$code-kbd-border-radius",
      "default": "3px !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$code-kbd-font-size",
      "default": "85% !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$code-kbd-font-weight",
      "default": "normal !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$code-padding",
      "default": ".2em .4em !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$kbd-padding",
      "default": ".2em .4rem !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$input-top-spacing",
      "default": "16px !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$text-field-active-label-height",
      "default": "12px !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$material-light",
      "default": "map-deep-merge(\n  (\n    'status-bar': (\n      'regular': map-get($grey, 'lighten-2'),\n      'lights-out': rgba(map-get($shades, 'white'), 0.7)\n    ),\n    'app-bar': map-get($grey, 'lighten-4'),\n    'background': map-get($shades, 'white'),\n    'bottom-navigation': map-get($shades, 'white'),\n    'surface': map-get($shades, 'white'),\n    'calendar': (\n      'background-color': map-get($shades, 'white'),\n      'outside-background-color': #f7f7f7,\n      'weeknumber-background-color': #f1f3f4,\n      'line-color': map-get($grey, 'lighten-2'),\n      'interval-color': map-get($grey, 'darken-3'),\n      'interval-line-color': map-get($grey, 'lighten-2'),\n      'text-color': map-get($shades, 'black'),\n      'past-color': rgba(map-get($shades, 'black'), .38)\n    ),\n    'cards': map-get($shades, 'white'),\n    'chips': #e0e0e0,\n    'code': (\n      'background': rgba(map-get($shades, 'black'), 0.05),\n      'color': currentColor\n    ),\n    'kbd': (\n      'background': #212529,\n      'color': map-get($shades, 'white')\n    ),\n    'dividers': rgba(map-get($shades, 'black'), 0.12),\n    'text': (\n      'theme': map-get($shades, 'white'),\n      'primary': rgba(map-get($shades, 'black'), 0.87),\n      'secondary': rgba(map-get($shades, 'black'), 0.6),\n      'disabled': rgba(map-get($shades, 'black'), 0.38),\n      'link': map-get($blue, 'darken-2'),\n      'link-hover': map-get($grey, 'darken-3')\n    ),\n    'icons': (\n      'active': rgba(map-get($shades, 'black'), 0.54),\n      'inactive': rgba(map-get($shades, 'black'), 0.38)\n    ),\n    'inputs': (\n      'box': rgba(map-get($shades, 'black'), 0.04),\n      'solo-inverted': rgba(map-get($shades, 'black'), 0.06),\n      'solo-inverted-focused': map-get($grey, 'darken-3'),\n      'solo-inverted-focused-label': rgba(map-get($shades, 'white'), .7),\n      'solo-inverted-focused-placeholder': rgba(map-get($shades, 'white'), 0.5),\n      'solo-inverted-focused-text': map-get($shades, 'white')\n    ),\n    'buttons': (\n      'disabled': rgba(map-get($shades, 'black'), 0.26),\n      'focused': rgba(map-get($shades, 'black'), 0.12),\n      'focused-alt': rgba(map-get($shades, 'white'), 0.6),\n      'pressed': rgba(#999, 0.4)\n    ),\n    'expansion-panels': (\n      'focus': map-get($grey, 'lighten-3')\n    ),\n    'navigation-drawer': map-get($shades, 'white'),\n    'selection-controls': (\n      'disabled': rgba(map-get($shades, 'black'), 0.26),\n      'thumb': (\n        'inactive': map-get($shades, 'white'),\n        'disabled': map-get($grey, 'lighten-5')\n      ),\n      'track': (\n        'inactive': rgba(map-get($shades, 'black'), 0.38),\n        'disabled': rgba(map-get($shades, 'black'), 0.12)\n      )\n    ),\n    'slider': (\n      'active': rgba(map-get($shades, 'black'), 0.38),\n      'inactive': rgba(map-get($shades, 'black'), 0.26),\n      'disabled': rgba(map-get($shades, 'black'), 0.26),\n      'discrete': map-get($shades, 'black')\n    ),\n    'skeleton': linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, .3), rgba(255, 255, 255, 0)),\n    'states': (\n      'hover': 0.04,\n      'focus': 0.12,\n      'selected': 0.08,\n      'activated': 0.12,\n      'pressed': 0.16,\n      'dragged': 0.08\n    ),\n    'tabs': rgba(0, 0, 0, 0.54),\n    'toggle-buttons': (\n      'color': map-get($shades, 'black')\n    ),\n    'text-fields': (\n      'filled': rgba(map-get($shades, 'black'), 0.06),\n      'filled-hover': rgba(map-get($shades, 'black'), 0.12),\n      'outlined': rgba(map-get($shades, 'black'), 0.38),\n      'outlined-disabled': rgba(map-get($shades, 'black'), 0.26),\n      'outlined-hover': rgba(map-get($shades, 'black'), 0.86)\n    ),\n    'toolbar': map-get($shades, 'white'),\n    'input-bottom-line': rgba(map-get($shades, 'black'), 0.42),\n    'stepper': (\n      'active': rgba(map-get($shades, 'white'), 1),\n      'completed': rgba(map-get($shades, 'black'), 0.87),\n      'hover': rgba(map-get($shades, 'black'), 0.54)\n    ),\n    'table': (\n      'active': map-get($grey, 'lighten-4'),\n      'hover': map-get($grey, 'lighten-3'),\n      'group': map-get($grey, 'lighten-3')\n    ),\n    'picker': (\n      'body': map-get($shades, 'white'),\n      'clock': map-get($grey, 'lighten-2'),\n      'indeterminateTime': map-get($grey, 'lighten-1'),\n      'title': map-get($grey, 'lighten-2')\n    ),\n    'color-picker': (\n      'checkerboard': rgba(map-get($shades, 'white'), 0)\n    ),\n    'bg-color': map-get($shades, 'white'),\n    'fg-color': map-get($shades, 'black'),\n    'text-color': map-get($shades, 'black'),\n    'primary-text-percent': 0.87,\n    'secondary-text-percent': 0.6,\n    'disabledORhints-text-percent': 0.38,\n    'divider-percent': 0.12,\n    'active-icon-percent': 0.54,\n    'inactive-icon-percent': 0.38\n  ),\n  $material-light\n);",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$material-dark-elevation-colors",
      "default": "() !default;",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$material-dark",
      "default": "map-deep-merge(\n  (\n    'status-bar': (\n      'regular': map-get($shades, 'black'),\n      'lights-out': rgba(map-get($shades, 'black'), 0.2)\n    ),\n    'app-bar': map-get($material-dark-elevation-colors, '4'),\n    'background': #121212,\n    'bottom-navigation': map-get($material-dark-elevation-colors, '8'),\n    'surface': #121212,\n    'calendar': (\n      'background-color': #303030,\n      'outside-background-color': #202020,\n      'weeknumber-background-color': #202020,\n      'line-color': map-get($grey, 'base'),\n      'interval-color': map-get($grey, 'lighten-3'),\n      'interval-line-color': map-get($grey, 'darken-2'),\n      'text-color': map-get($shades, 'white'),\n      'past-color': rgba(map-get($shades, 'white'), .50)\n      ),\n    'cards': map-get($material-dark-elevation-colors, '1'),\n    'chips': #555,\n    'code': (\n      'background': rgba(map-get($shades, 'white'), 0.1),\n      'color': currentColor\n    ),\n    'kbd': (\n      'background': #212529,\n      'color': map-get($shades, 'white')\n    ),\n    'dividers': rgba(map-get($shades, 'white'), 0.12),\n    'text': (\n      'theme': map-get($shades, 'white'),\n      'primary': map-get($shades, 'white'),\n      'secondary': rgba(map-get($shades, 'white'), 0.7),\n      'disabled': rgba(map-get($shades, 'white'), 0.5),\n      'link': map-get($blue, 'accent-1'),\n      'link-hover': map-get($grey, 'lighten-3')\n    ),\n    'icons': (\n      'active': map-get($shades, 'white'),\n      'inactive': rgba(map-get($shades, 'white'), 0.5)\n    ),\n    'inputs': (\n      'box': map-get($shades, 'white'),\n      'solo-inverted': rgba(map-get($shades, 'white'), 0.16),\n      'solo-inverted-focused': map-get($shades, 'white'),\n      'solo-inverted-focused-label': rgba(map-get($shades, 'black'), .6),\n      'solo-inverted-focused-placeholder': rgba(map-get($shades, 'black'), 0.38),\n      'solo-inverted-focused-text': rgba(map-get($shades, 'black'), 0.87)\n    ),\n    'buttons': (\n      'disabled': rgba(map-get($shades, 'white'), 0.3),\n      'focused': rgba(map-get($shades, 'white'), 0.12),\n      'focused-alt': rgba(map-get($shades, 'white'), 0.1),\n      'pressed': rgba(#ccc, 0.25)\n    ),\n    'expansion-panels': (\n      'focus': #494949\n    ),\n    'navigation-drawer': map-get($material-dark-elevation-colors, '16'),\n    'selection-controls': (\n      'disabled': rgba(map-get($shades, 'white'), 0.3),\n      'thumb': (\n        'inactive': map-get($grey, 'lighten-1'),\n        'disabled': map-get($grey, 'darken-3')\n      ),\n      'track': (\n        'inactive': rgba(map-get($shades, 'white'), 0.3),\n        'disabled': rgba(map-get($shades, 'white'), 0.1)\n      )\n    ),\n    'slider': (\n      'active': rgba(map-get($shades, 'white'), 0.3),\n      'inactive': rgba(map-get($shades, 'white'), 0.2),\n      'disabled': rgba(map-get($shades, 'white'), 0.2),\n      'discrete': map-get($shades, 'white')\n    ),\n    'skeleton': linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, .05), rgba(255, 255, 255, 0)),\n    'states': (\n      'hover': 0.08,\n      'focus': 0.24,\n      'selected': 0.16,\n      'activated': 0.24,\n      'pressed': 0.32,\n      'dragged': 0.16\n    ),\n    'tabs': rgba(map-get($shades, 'white'), 0.6),\n    'toggle-buttons': (\n      'color': map-get($shades, 'white')\n    ),\n    'text-fields': (\n      'filled': rgba(map-get($shades, 'white'), 0.08),\n      'filled-hover': rgba(map-get($shades, 'white'), 0.16),\n      'outlined': rgba(map-get($shades, 'white'), 0.24),\n      'outlined-disabled': rgba(map-get($shades, 'white'), 0.16),\n      'outlined-hover': map-get($shades, 'white')\n    ),\n    'input-bottom-line': rgba(map-get($shades, 'white'), 0.7),\n    'stepper': (\n      'active': rgba(map-get($shades, 'white'), 1),\n      'completed': rgba(map-get($shades, 'white'), 0.87),\n      'hover': rgba(map-get($shades, 'white'), 0.75)\n    ),\n    'table': (\n      'active': #505050,\n      'hover': map-get($grey, 'darken-2'),\n      'group': map-get($grey, 'darken-2')\n    ),\n    'toolbar': map-get($material-dark-elevation-colors, '4'),\n    'picker': (\n      'body': map-get($grey, 'darken-3'),\n      'clock': map-get($grey, 'darken-2'),\n      'indeterminateTime': map-get($grey, 'darken-1'),\n      'title': map-get($grey, 'darken-2')\n    ),\n    'color-picker': (\n      'checkerboard': rgba(map-get($shades, 'white'), 0.12)\n    ),\n    'bg-color': #303030,\n    'fg-color': map-get($shades, 'white'),\n    'text-color': map-get($shades, 'white'),\n    'primary-text-percent': 1,\n    'secondary-text-percent': 0.7,\n    'disabledORhints-text-percent': 0.5,\n    'divider-percent': 0.12,\n    'active-icon-percent': 1,\n    'inactive-icon-percent': 0.5\n  ),\n  $material-dark\n);",
      "description": {
        "en": "",
        "zh-Hans": "",
        "eo-UY": ""
      }
    }
  ]
}